import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';

import AppLayout from './layouts/AppLayout';
import {Brand} from "./Brand";
import './index.css';

// doesn't work with BrowserRouter (only with Router)
// import {createBrowserHistory} from "history";
// const hist = createBrowserHistory();

// customized theme (note: the MKR components have their own customizations in JS, and require their classes applied)
const theme = createMuiTheme({
  typography: {
    ...Brand.muiThemeTypography,
  },
  palette: {
    ...Brand.muiThemePalette,
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline/>
    {/* history={hist}  */}
    <BrowserRouter basename={process.env.PUBLIC_URL || ''}>
      <AppLayout/>
    </BrowserRouter>
  </ThemeProvider>,
  document.querySelector('#root'),
);
